import { Box } from "arkh";
import React from "react";
import { Header } from "@react-navigation/elements";
import { HeaderButton } from "../../../components";
import { TodoBottomSheetMainHeaderLeft } from "./TodoBottomSheetMainHeaderLeft";
import { TodoBottomSheetStackScreenProps } from "./TodoBottomSheetStack";
import { Platform } from "react-native";

type Props = {
  headerLeft: "DONE" | "BACK" | undefined;
  headerRight?: () => React.ReactNode;
  navigation?: TodoBottomSheetStackScreenProps<any>["navigation"];
  onDone?: () => void;
  title: string;
};
export function TodoBottomSheetHeader(options: Props) {
  const headerOptions = {
    title: options.title,
    headerLeft:
      options.headerLeft === "DONE"
        ? () => <TodoBottomSheetMainHeaderLeft />
        : options.headerLeft === "BACK"
          ? () => (
              <HeaderButton
                type="BACK"
                onPress={() => {
                  options.onDone?.();
                  options.navigation?.goBack();
                }}
              />
            )
          : undefined,
    headerRight: options.headerRight,
    headerShadowVisible: false,
    headerStyle: {
      height: 40,
    },
  };

  return (
    <Box
      spaceHorizontal="medium"
      color="surface-primary"
      borderColor="border-primary"
      spaceLeft={
        Platform.OS === "web" && options.headerLeft === "BACK"
          ? "none"
          : "medium"
      }
    >
      <Header {...headerOptions} headerStatusBarHeight={0} />
    </Box>
  );
}
export function getTodoBottomSheetScreenOptions(options: Props) {
  return {
    header: () => <TodoBottomSheetHeader {...options} />,
  };
}
